import React, { useState } from 'react';
import { TextEditor } from '../Editor';
import { useFormContext } from '@/providers';

const WelcomeMessageInstructions = () => {
    const { watch, setValue, errors, fieldRefs } = useFormContext();
    const [selectedInstructions, setSelectedInstructions] = useState([]);

    const handleInstructionSelect = (e) => {
        const newInstruction = e.target.value;
        if (newInstruction && !selectedInstructions.includes(newInstruction)) {
            const updatedInstructions = [...selectedInstructions, newInstruction];
            setSelectedInstructions(updatedInstructions);
            setValue('welcome_message', updatedInstructions.join('\n\n'));

            // Instead of resetting, we'll keep the selection but prevent duplicates
            // The user can see what they've selected in the editor
        }
    };

    const handleTextEditorChange = (content) => {
        setValue('welcome_message', content);
        // Update selectedInstructions if needed
        setSelectedInstructions(content.split('\n\n').filter(instruction => instruction.trim() !== ''));
    };

    return (
        <>
            <div className="mt-2 text-left md:col-span-12">
                <label>
                    Welcome and Instructions - this message will be sent to your
                    guest once the reservation is confirmed and paid.
                    <i className="fal fa-clock" />
                </label>
                <select
                    name="welcome_message"
                    placeholder="Instructions"
                    ref={(el) => (fieldRefs.current['welcome_message'] = el)}
                    onChange={handleInstructionSelect}
                    defaultValue="" // Controlled component with empty value
                    className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                >
                    <option disabled value="">
                        Choose as many instructions as you would like. Feel free
                        to edit or add your own.
                    </option>
                    <option value="We're delighted to have you stay with us! To make your arrival seamless, here's everything you need to know:">
                        We're delighted to have you stay with us! To make your
                        arrival seamless, here's everything you need to know:
                    </option>
                    <option
                        style={{ fontWeight: "bolder" }}
                        value="1. Check-in Instructions:"
                    >
                        1. Check-in Instructions:
                    </option>
                    <option value="Address: [Insert full address with any special notes, like landmarks].">
                        Address: [Insert full address with any special notes, like
                        landmarks].
                    </option>
                    <option value="Entry Code: Use [insert code] at the front door keypad to unlock. Ensure you press [insert instructions] after entering the code.">
                        Entry Code: Use [insert code] at the front door keypad to
                        unlock. Ensure you press [insert instructions] after
                        entering the code.
                    </option>
                    <option value="Check-in Time: [Insert time, e.g., 3:00 PM].">
                        Check-in Time: [Insert time, e.g., 3:00 PM].
                    </option>
                    <option value="Parking: [Provide parking details, such as designated spots or street parking tips].">
                        Parking: [Provide parking details, such as designated
                        spots or street parking tips].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="2. Wi-Fi Information:"
                    >
                        2. Wi-Fi Information:
                    </option>
                    <option value="Network Name: [Insert Wi-Fi name].">
                        Network Name: [Insert Wi-Fi name].
                    </option>
                    <option value="Password: [Insert password].">
                        Password: [Insert password].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="3. Appliance Use:"
                    >
                        3. Appliance Use:
                    </option>
                    <option value="Thermostat: [Explain how to use it and preferred temperature settings].">
                        Thermostat: [Explain how to use it and preferred
                        temperature settings].
                    </option>
                    <option value="Kitchen Appliances: Feel free to use all appliances. Please ensure the oven and stovetop are turned off after use.">
                        Kitchen Appliances: Feel free to use all appliances.
                        Please ensure the oven and stovetop are turned off after
                        use.
                    </option>
                    <option value="Washer/Dryer: [Insert operating instructions if available for use].">
                        Washer/Dryer: [Insert operating instructions if available
                        for use].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="4. Emergency Contacts:"
                    >
                        4. Emergency Contacts:
                    </option>
                    <option value="Host Contact: [Insert phone number or message option].">
                        Host Contact: [Insert phone number or message option].
                    </option>
                    <option value="Local Emergency Services: Dial [insert number, e.g., 911].">
                        Local Emergency Services: Dial [insert number, e.g., 911].
                    </option>
                    <option value="Nearest Hospital/Clinic: [Insert address and contact].">
                        Nearest Hospital/Clinic: [Insert address and contact].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="5. Check-Out Instructions:"
                    >
                        5. Check-Out Instructions:
                    </option>
                    <option value="Check-Out Time: [Insert time, e.g., 11:00 AM].">
                        Check-Out Time: [Insert time, e.g., 11:00 AM].
                    </option>
                    <option value="Cleaning Up: Please leave used towels in the bathroom and ensure all dishes are washed or placed in the dishwasher.">
                        Cleaning Up: Please leave used towels in the bathroom and
                        ensure all dishes are washed or placed in the dishwasher.
                    </option>
                    <option value="Trash: [Insert instructions for trash disposal, e.g., place bags in the outdoor bin].">
                        Trash: [Insert instructions for trash disposal, e.g.,
                        place bags in the outdoor bin].
                    </option>
                    <option value="Keys: [Insert details if a key is used, e.g., leave it in the lockbox or on the counter].">
                        Keys: [Insert details if a key is used, e.g., leave it in
                        the lockbox or on the counter].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="6. Local Recommendations:"
                    >
                        6. Local Recommendations:
                    </option>
                    <option value="Grocery Stores: [Insert name and distance of the nearest store].">
                        Grocery Stores: [Insert name and distance of the nearest
                        store].
                    </option>
                    <option value="Restaurants: Check out [insert 2-3 restaurant suggestions].">
                        Restaurants: Check out [insert 2-3 restaurant
                        suggestions].
                    </option>
                    <option value="Activities: We recommend [insert local attractions].">
                        Activities: We recommend [insert local attractions].
                    </option>

                    <option
                        style={{ fontWeight: "bolder" }}
                        value="7. Additional Notes:"
                    >
                        7. Additional Notes:
                    </option>
                    <option value="Welcome Basket: Enjoy a small welcome basket with [insert items, e.g., snacks, water bottles].">
                        Welcome Basket: Enjoy a small welcome basket with [insert
                        items, e.g., snacks, water bottles].
                    </option>
                    <option value="Guidebook: There's a digital or physical guidebook provided with more detailed instructions and recommendations.">
                        Guidebook: There's a digital or physical guidebook
                        provided with more detailed instructions and
                        recommendations.
                    </option>
                    <option value="Respect Our Neighbors: Please be considerate of our community.">
                        Respect Our Neighbors: Please be considerate of our
                        community.
                    </option>
                    <option value="Thank you for choosing to stay with us! We hope you have a fantastic visit. Feel free to reach out with any questions or concerns.">
                        Thank you for choosing to stay with us! We hope you have a
                        fantastic visit. Feel free to reach out with any questions
                        or concerns.
                    </option>
                </select>
                {errors?.welcome_message && (
                    <p style={{ color: "red" }}>
                        {errors?.welcome_message?.message}
                    </p>
                )}
            </div>

            <div className="mt-2 text-left md:col-span-12">
                <label>Edit Information</label>
            </div>

            <div className="mt-2 text-left md:col-span-12">
                <TextEditor
                    field={'welcome_message'}
                    value={watch('welcome_message') || ''}
                    onChange={handleTextEditorChange}
                />
            </div>
            <div className="mt-5 text-left md:col-span-12">
                {errors?.welcome_message && (
                    <p style={{ color: "red" }}>
                        {errors?.welcome_message?.message}
                    </p>
                )}
            </div>
        </>
    );
};

export default WelcomeMessageInstructions;